import React, { Fragment, Component } from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Collapse,
  ButtonGroup,
  Alert,
} from "reactstrap";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { ErrorAlert } from "../../../../../helpers/ui/alert_new";
import Select from "../../../../../helpers/ui/CustomSelect";
import {
  FileInput,
  generateFormData,
  generateFormDataMultiple,
} from "../../../../../helpers/ui/FileInput";
import { AvForm, AvField } from "availity-reactstrap-validation";

import { withRouter } from "react-router-dom";
import apiResponse from "../../../../../services/apiResponse";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService";
import IndexBloc from "../../Index/Blocs/IndexBloc";
import CreateBloc from "../Blocs/CreateBloc";
import DatePicker from "../../../../../helpers/ui/DatePicker";
import _ from "lodash";

const reformatDate = (date) => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(date);
  let dt = d.getDate();
  if (dt < 10) dt = "0" + dt;

  if (date) {
    return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
  }
  //console.log(dt);
  return "-";
};
var reformatOptions = (raw, label, value) => {
  return raw.map(function (data) {
    var newObj = {};
    if (data["position_grade"] != null && data["position_grade"] > 0) {
      newObj["label"] = data[label] + " (Grade " + data["position_grade"] + ")";
    } else {
      newObj["label"] = data[label];
    }

    newObj["value"] = data[value];
    newObj["model"] = data;
    //console.log(newObj);
    return newObj;
  });
};
class UpdateModal extends Component {
  indexBloc = new IndexBloc();
  createBloc = new CreateBloc();
  timer;
  source;
  defaultSize = 10;

  constructor(props) {
    super(props);
    this.state = {
      selectedEmployee: null,
      detailMutasi: null,
      dataForm: null,
      employeeOption: [],
      workUnitOption: [],
      positionOption: [],
      jabatanOption: [],
      selectedMinistry: 1,
      countryOption: [],
      coupleOption: [],
      childOption: [],
      selectedChild: null,
      pemberhentianType: null,
      show_jenis_jabatan: 1,
      selected_jabatan: null,
      type: this.props.type,
      employeeFilter: {
        filter_value: "",
        page_number: 1,
        page_size: this.defaultSize,
        sort_order: {
          column: "employee_id",
          order: "asc",
        },
      },
      workUnitFilter: {
        filter_value: "",
        page_number: 1,
        page_size: this.defaultSize,
        sort_order: {
          column: "work_unit_id",
          order: "asc",
        },
      },
      positionFilter: {
        filter_value: "",
        page_number: 1,
        page_size: 9999,
        sort_order: {
          column: "position_id",
          order: "asc",
        },
      },
      position_type: 1,
      quota: -1,
      msg: "",
    };
  }

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        uuid: this.props.uuid,
        employee_transfer_detail_uuid: this.props.detailUuid,
        employee_transfer_detail_ministry: this.state.selectedMinistry,
        ...values,
      },
      confirm: true,
    });
  };

  handlePegawaiSelected = (employee_uuid) => {
    let selected = employee_uuid.value;
    // console.log(selected);
    // if (selected == "Dalam Negeri") {
    //     this.setState({
    //         birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
    //         isLocal: 1
    //     })
    // } else {
    //     this.setState({
    //         birthSelectedCountry: "",
    //         isLocal: 0
    //     })
    // }
  };
  loadEmployee = async () => {
    const query = {
      uuid: this.props.uuid,
    };
    this.setState({ loadingEmployee: true });
    await this.indexBloc.fetchListPegawai(query);
  };

  loadWorkUnit = async () => {
    let offset =
      (this.state.workUnitFilter.page_number - 1) *
      this.state.workUnitFilter.page_size;
    const query = {
      search: this.state.workUnitFilter.filter_value,
      limit: this.state.workUnitFilter.page_size,
      offset: offset,
      order: this.state.workUnitFilter.sort_order.column,
      sort: this.state.workUnitFilter.sort_order.order,
      status: 1,
    };
    this.setState({ loadingWorkUnit: true });
    await this.indexBloc.fetchListUnitKerja(query);
  };

  loadPosition = async (uuid) => {
    // console.log("wu uuid : " + uuid);
    // console.log("load posisi : " + this.state.position_type);

    if (this.state.selectedEmployee) {
      if (uuid == "") {
        uuid = this.state.selectedEmployee?.employee_current_work_unit_uuid;
      }
      // console.log('ghany')
      // console.log(this.state.selectedEmployee)
    }
    //console.log(this.state.detailMutasi?);
    let offset =
      (this.state.positionFilter.page_number - 1) *
      this.state.positionFilter.page_size;
    const query = {
      uuid: uuid,
      search: this.state.positionFilter.filter_value,
      limit: this.state.positionFilter.page_size,
      offset: offset,
      order: this.state.positionFilter.sort_order.column,
      sort: this.state.positionFilter.sort_order.order,
      status: 1,
      position_type: this.state.position_type,
    };
    this.setState({ loadingPosition: true });
    await this.indexBloc.fetchListJabatan(query);
  };

  loadRegion = async () => {
    await this.indexBloc.fetchRegion({ type: 1 });
  };

  loadGrade = async () => {
    await this.createBloc.fetchGrade();
  };

  loadDetail = async (uuid) => {
    const query = {
      uuid: uuid,
    };
    await this.indexBloc.fetchDetailMutasi(query);
  };

  convertToFormData(data) {
    const formData = new FormData();

    for (const key in data) {
      const value = data[key];
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (Array.isArray(item)) {
              item.forEach((itm, idx) => {
                if (itm !== null && itm !== undefined) {
                  formData.append(`${key}[${index}][]`, itm);
                }
              });
            } else {
              formData.append(`${key}[]`, item);
            }
          });
        } else {
          formData.append(key, value);
        }
      }
    }

    return formData;
  }
  submitData = async () => {
    // const dataForm = generateFormData(this.state.dataForm, {field: "file", name: "employee_transfer_detail_kemenlu_decree_document"})
    //const formData = generateFormData(this.state.dataForm, ['file', 'employee_transfer_detail_kemenlu_decree_document'])
    const formData = this.convertToFormData({
      ...this.state.dataForm,
      uuid: this.props.uuid,
    });
    await this.createBloc.fetchUpdate(formData);
  };

  // Pengecekkan quota pada peta jabatan
  checkQuota = async (uuid) => {
    await this.createBloc.checkPositionQuota({
      position_uuid: uuid,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  confirmResponse2 = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        // this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failedBmn: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadEmployee();
    this.loadWorkUnit();
    this.loadPosition("");
    this.loadGrade();
  };

  componentDidMount() {
    this.setTokenAPI();

    this.createBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState({
              loading: false,
              success: true,
            });
            this.props.toggle();
            this.props.handleReload();
          } else {
            this.setState({
              loading: false,
              failed: true,
              failedInfo: result.data.message,
            });
            this.props.toggle();
          }
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
            failedInfo: result.data.message,
          });
          this.props.toggle();
          break;
        default:
          break;
      }
    });

    this.indexBloc.listPegawaiChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            employeeOption: result.data.response.result,
            loadingEmployee: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.listUnitKerjaChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            workUnitOption: result.data.response.result,
            loadingWorkUnit: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.listJabatanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            positionOption: result.data.response.result,
            loadingPosition: false,
          });
          this.setState({
            jabatanOption: reformatOptions(
              result.data.response.result,
              "position_name",
              "position_uuid"
            ),
          });

          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.detailMutasiChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          let obj = this.state.employeeOption.find(
            (o) =>
              o.employee_uuid ===
              result.data.response.employee_transfer_detail_employee_uuid
          );
          this.setState({
            detailMutasi: result.data.response,
            selectedEmployee: obj,
            type: result.data.response.employee_transfer_detail_type,
            pemberhentianType:
              result.data.response.employee_transfer_detail_position_type,
            selectedMinistry:
              result.data.response.employee_transfer_detail_ministry,
            loading: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.regionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            countryOption: result.data.response.result,
            loadingCountry: false,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.gradeListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            gradeListOption: result.data?.response?.result,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
    this.createBloc.createDetailChannel?.unsubscribe();
    // this.indexBloc.listPegawaiChannel?.unsubscribe();
    this.indexBloc.listUnitKerjaChannel?.unsubscribe();
    this.indexBloc.listJabatanChannel?.unsubscribe();
    this.indexBloc.detailMutasiChannel?.unsubscribe();
    this.indexBloc.regionChannel?.unsubscribe();
  }

  componentDidUpdate(prevProps, prevState) {
    // this.loadPosition("")
    // this.loadPosition("");
    // if (prevProps.modal !== this.props.modal) {
    //   if (this.props.modal == false) {
    //     this.setState({
    //       selectedEmployee: null,
    //       type: null,
    //       dataForm: null,
    //       detailMutasi: null,
    //     });
    //   }else{
    //     this.setState({
    //       type: this.props.type,
    //       selectedEmployee: this.props.employee_transfer_detail_employee_uuid,
    //     });
    //     if (this.props.uuid) {
    //       this.loadDetail(this.props.uuid);
    //       this.loadPosition("")
    //     }
    //   }
    // }
    // if (prevProps.uuid !== this.props.uuid) {
    // if (this.props.uuid) {
    //   this.loadDetail(this.props.uuid);
    // }
    // }
    // if (prevState.pemberhentianType !== this.state.pemberhentianType) {
    //   if (
    //     this.state.pemberhentianType == 1 ||
    //     this.state.pemberhentianType == 2 ||
    //     this.state.pemberhentianType == 3
    //   ) {
    //     this.setState({
    //       loadingCountry: true,
    //       loadingCouple: true,
    //       loadingChild: true,
    //     });
    //     this.loadRegion();
    //     this.loadFamilyOptions();
    //   }
    // }
    // if (prevState.selectedEmployee !== this.state.selectedEmployee) {
    //   this.setState({
    //     childOption: [],
    //     loadingChild: true,
    //     coupleOption: [],
    //     loadingCouple: true,
    //   });
    //   this.loadFamilyOptions();
    // }
  }

  render() {
    // const { selectedEmployee, type, detailMutasi } = this.state;
    const selectedEmployee = this.state.selectedEmployee,
      type = this.props.type,
      detailMutasi = this.state.detailMutasi;
    return (
      <Fragment>
        <Modal
          isOpen={this.props.modal}
          size="xl"
          centered={true}
          toggle={this.props.toggle}
        >
          <ModalHeader toggle={this.props.toggle}>
            Lengkapi Mutasi Pegawai
          </ModalHeader>
          <ModalBody>
            <AvForm
              className="needs-validation"
              onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
            >
              {/* <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Jenis Mutasi <span className="text-danger">*</span>
                </Label>
                <Col md="9">
                  <Select
                    name="employee_transfer_detail_type"
                    options={[
                      { value: 1, label: "SK Pengangkatan Jabatan" },
                      {
                        value: 2,
                        label: "SK Pemberhentian & Pengangkatan Jabatan",
                      },
                      { value: 3, label: "SK Pemberhentian Jabatan" },
                    ]}
                    onChange={(opt) => this.setState({ type: opt.value })}
                    defaultValue={this.props.type}
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row> */}

              <Row className="mb-3 mt-3">
                <Label className="col-md-3 col-form-label">Nip</Label>
                <Col md="9">
                  <Input value={this.props?.nip} type="text" readOnly={true} />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">Nama</Label>
                <Col md="9">
                  <Input value={this.props?.nama} type="text" readOnly={true} />
                </Col>
              </Row>
              {/* <Row className="mb-3">
                <Label className="col-md-3 col-form-label">Pangkat</Label>
                <Col md="9">
                  <Input
                    value={
                      selectedEmployee?.employee_current_rank_group_room
                    }
                    type="text"
                    readOnly={true}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Unit Kerja
                </Label>
                <Col md="9">
                  <Input
                    value={
                      selectedEmployee?.employee_current_work_unit_name
                    }
                    type="textarea"
                    readOnly={true}
                  />
                </Col>
              </Row> */}
              <hr />

              {/* <Label>Informasi Jabatan Lama</Label>
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Unit Kerja
                </Label>
                <Col md="9">
                  <AvField
                    name="employee_transfer_detail_old_work_unit_uuid"
                    type="hidden"
                    value={
                      selectedEmployee?.employee_current_work_unit_uuid
                    }
                  />
                  <Input
                    value={
                      selectedEmployee?.employee_current_work_unit_name
                    }
                    type="textarea"
                    readOnly={true}
                  />
                </Col>
              </Row> */}
              {/* <Row className="mb-3">
                <Label className="col-md-3 col-form-label">Jabatan</Label>
                <Col md="9">
                  <AvField
                    name="employee_transfer_detail_old_position_uuid"
                    type="hidden"
                    value={
                      selectedEmployee?.employee_current_position_uuid
                    }
                  />
                  <Input
                    value={
                      selectedEmployee?.employee_current_position_name
                    }
                    type="text"
                    readOnly={true}
                  />
                </Col>
              </Row> */}

              <hr />
              {/* <Label>Informasi Jabatan Baru</Label> */}

              {/* <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Unit Kerja Baru
                  <span className="text-danger">*</span>
                </Label>
                <Col md="9">
                  
                    <Select
                      name="employee_transfer_detail_work_unit_uuid"
                      defaultValue={
                        detailMutasi
                          ? detailMutasi?.employee_transfer_detail_work_unit_uuid
                          : selectedEmployee?.employee_current_work_unit_uuid
                      }
                      options={this.state.workUnitOption}
                      optionLabel="work_unit_name_reverse"
                      optionValue="work_unit_uuid"
                      errorMessage="Masukkan Unit Kerja Baru"
                      onChange={(opt) =>
                        this.loadPosition(opt.work_unit_uuid)
                      }
                      onInputChange={(value) => {
                        if (value) {
                          clearTimeout(this.timer);
                          this.state.workUnitFilter.filter_value =
                            value;
                          this.timer = setTimeout(
                            () => this.loadWorkUnit(),
                            1000
                          );
                        }
                      }}
                      isLoading={this.state.loadingWorkUnit}
                      validate={{ required: { value: true } }}
                    />
                  
                </Col>
              </Row> */}
              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Jenis Jabatan<span className="text-danger">*</span>
                </Label>
                <Col md="9">
                  <Select
                    name="employee_transfer_detail_position_type"
                    options={[
                      // { value: '', label: "Pilih jenis jabatan" },
                      { value: 1, label: "Struktural" },
                      { value: 2, label: "Fungsional Umum" },
                      { value: 20, label: "Fungsional Tertentu" },
                    ]}
                    errorMessage="Pilih Jenis Jabatan"
                    defaultValue={
                      this.props.employee_transfer_detail_position_type
                    }
                    // onChange={(opt) =>
                    //   this.setState(
                    //     {
                    //       position_type: opt.value,
                    //     },
                    //     () => this.loadPosition("")
                    //   )
                    // }
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>
              {/* <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Jabatan <span className="text-danger">*</span>
                </Label>
                <Col md="9">
                  <Select
                    name="employee_transfer_detail_position_uuid"
                    defaultValue={detailMutasi?.employee_transfer_detail_position_uuid}
                    //options={this.state.positionOption}
                    options={this.state.jabatanOption}
                    // optionLabel="position_name"
                    // optionValue="position_uuid"
                    errorMessage="Pilih Jabatan"
                    isLoading={this.state.loadingPosition}
                    validate={{ required: { value: true } }}
                    onChange={(selectedOption) => {
                      // Get the selected value here
                      const selectedValue = selectedOption.value;
                      console.log(
                        "Selected Position UUID: ",
                        selectedValue
                      );

                      // Update the state or do something with the selected value
                      // this.setState({
                      //   selectedPosition: selectedValue
                      // });
                      this.checkQuota(selectedValue);
                    }}
                  />
                </Col>
              </Row> */}

              {/* <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Nomor SK /Tanggal SK
                  <span className="text-danger">*</span>
                </Label>
                <Col md="9">
                  <Row>
                    <Col md="6">
                      <AvField
                        name="employee_transfer_detail_decree_number"
                        value={
                          detailMutasi?.employee_transfer_detail_decree_number
                        }
                        placeholder="Nomor SK"
                        type="text"
                        errorMessage="Masukkan No Surat Keputusan"
                        validate={{ required: { value: false } }}
                      />
                    </Col>
                    <Col md="6">
                      <div className="customDatePickerWidth">
                        
                        <AvField
                          type="date"
                          name="employee_transfer_detail_decree_date"
                          id="employee_transfer_detail_decree_date"
                          placeholder="Tanggal SK"
                          errorMessage="Masukkan Tanggal SK"
                          value={
                            detailMutasi?.employee_transfer_detail_decree_date
                          }
                          validate={{ required: { value: false } }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row> */}

              {/* <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  TMT <span className="text-danger">*</span>
                </Label>
                <Col md="9">
                  <div className="customDatePickerWidth">
                    
                    <AvField
                      type="date"
                      name="employee_transfer_detail_tmt_date"
                      id="employee_transfer_detail_tmt_date"
                      placeholder="Tanggal TMT"
                      errorMessage="Masukkan Tanggal TMT"
                      validate={{ required: { value: true } }}
                      value={
                        detailMutasi?.employee_transfer_detail_tmt_date
                      }
                    />
                  </div>
                </Col>
              </Row> */}

              <Row className="mb-3">
                <Label className="col-md-3 col-form-label">
                  Pejabat Penetap <span className="text-danger">*</span>
                </Label>
                <Col md="9">
                  <AvField
                    name="employee_transfer_detail_signatories_official"
                    value={
                      this.props.employee_transfer_detail_signatories_official
                    }
                    placeholder="Pejabat Penetap..."
                    type="text"
                    errorMessage="Masukkan Pejabat Penetap"
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              {this.props.employee_categories_parent_uuid ==
                "f3dd847a-ed83-4539-9a16-7df9048cd42b" && (
                <>
                  <Row className="mb-3">
                    <label
                      htmlFor="mapping_grade_tunsus_grade_special_level_uuid"
                      className="col-md-3 col-form-label"
                    >
                      Grade Tunsus <span className="text-danger">*</span>
                    </label>
                    <Col md="3">
                      <Select
                        name="mapping_grade_tunsus_grade_special_level_uuid"
                        placeholder="Grade Tunsus..."
                        errorMessage="Grade Tunsus"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        options={this.state.gradeListOption}
                        optionLabel="special_level_code"
                        optionValue="special_level_uuid"
                        isLoading={
                          !this.props
                            .employee_transfer_detail_grade_special_level_uuid
                        }
                        defaultValue={
                          this.props
                            .employee_transfer_detail_grade_special_level_uuid
                        }
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label
                      htmlFor="mapping_grade_tunsus_grade_special_level_uuid"
                      className="col-md-3 col-form-label"
                    >
                      Berlaku Dari <span className="text-danger">*</span>
                    </label>
                    <Col md="3">
                      <AvField
                        name={`mapping_grade_tunsus_grade_start_date`}
                        type="date"
                        errorMessage="MasukkanTanggal Mulai Berlaku"
                        validate={{ required: { value: true } }}
                        placeholder="Tanggal Mulai Berlaku"
                        value={
                          this.props.employee_transfer_detail_grade_start_date
                        }
                      />
                    </Col>
                  </Row>
                </>
              )}

              <ModalFooter>
                <Button color="secondary" onClick={this.props.toggle}>
                  Cancel
                </Button>{" "}
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </ModalFooter>
            </AvForm>
          </ModalBody>
        </Modal>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin data tersebut sudah benar?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          // failedInfo={this.state.failedInfo}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
      </Fragment>
    );
  }
}

export default withRouter(UpdateModal);
